<template>
    <div>
        <div class="columns">
            <div class="column">
                <section class="section has-text-centered">
                    <h1 class="is-size-3 has-text-white mb-4">Warranty Archive</h1>
                    <b-table 
                    :data="warranties"
                    :loading="loading"
                    :total="total"
                    paginated
                    backend-pagination
                    :per-page="20" 
                    @page-change="onPageChange"
                    :current-page.sync="currentPage"
                    :pagination-simple="false" 
                    pagination-position="bottom" 
                    striped>
                        <b-table-column field="request_number" label="Request #" width="40" searchable v-slot="props">
                            {{ props.row.request_number }}
                        </b-table-column>
                        <b-table-column field="status" label="Status" width="40" sortable v-slot="props">
                            {{ props.row.status }}
                        </b-table-column>
                        <b-table-column field="primary_contact" label="Primary Contact" width="40" searchable v-slot="props">
                            {{ props.row.primary_contact }}
                        </b-table-column>
                        <b-table-column field="serial_id" label="Serial ID" width="40" searchable v-slot="props">
                            {{ props.row.serial_id }}
                        </b-table-column>
                        <b-table-column field="freight_cost" label="Freight Cost" width="40" sortable v-slot="props">
                            {{ props.row.freight_cost }}
                        </b-table-column>
                        <b-table-column field="labor_rate" label="Labor Rate" width="40" sortable v-slot="props">
                            {{ props.row.labor_rate }}
                        </b-table-column>
                        <b-table-column field="service_code_1" label="Serivce Code #1" width="40" searchable v-slot="props">
                            {{ props.row.service_code_1 }}
                        </b-table-column>
                        <b-table-column field="service_code_2" label="Service Code #2" width="40" searchable v-slot="props">
                            {{ props.row.service_code_2 }}
                        </b-table-column>
                        <b-table-column field="service_code_3" label="Service Code #3" width="40" searchable v-slot="props">
                            {{ props.row.service_code_3 }}
                        </b-table-column>
                        <b-table-column field="comment" label="Comment" width="40" v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>
                        <b-table-column field="dvo_comment" label="DVO Comment" width="40" v-slot="props">
                            {{ props.row.dvo_comment }}
                        </b-table-column>
                        <b-table-column field="date_created" label="Date Created " width="40" sortable v-slot="props">
                            {{ props.row.date_created }}
                        </b-table-column>
                        <b-table-column field="date_completed" label="Date Completed" width="40" sortable v-slot="props">
                            {{ props.row.date_completed }}
                        </b-table-column>
                    </b-table>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { getArchivedWarranties } from '../graphql/queries';
    
export default {
  data(){
    return{
      warranties:[],
      currentPage: 1,
      perPage: 20,
      loading: false,
      total: 5936,
      defaultSortDirection: 'asc',
      page: 1
    }
  },
  methods: {
  async getWarrantyArchive() {
    this.loading = true
    this.warranties = []

    const Warranties = await API.graphql({
        query: getArchivedWarranties,
        variables:{
        input: {
            request_type: 'read_all', 
            limit: this.perPage,
            page: this.currentPage
         }
        }
    });

    this.warranties = Warranties.data.getArchivedWarranties;
    this.loading = false
    },
    onPageChange(page) {
        this.page = page
        this.getWarrantyArchive()
    },
  },
  async mounted() { 
    this.getWarrantyArchive()
  },
}
</script>

<style>
i{
  cursor: pointer;
}
.pagination-link{
  color: white !important;
}
</style>